import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link, useParams } from "react-router-dom";
import { Row, Col, Dropdown } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import { Modal, Form } from "react-bootstrap";
import Select from 'react-select';
import axios from "axios";
import './UserProfilePage.css';
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import { formatPhoneNumber } from "../../utils/formatPhone";
import moment from "moment";

export default function ConsultationviewPage() {

    const { t } = useContext(TranslatorContext)
    const { consultation_id } = useParams();
    const [Data, setData] = useState('');
    const [hospitalResponse, sethospitalResponse] = useState();
    const [ClinicId, setClinicId] = useState('');
    const [doctorData, setdoctorData] = useState([]);
    const [enlargedImage, setEnlargedImage] = useState(null);
    const [showImagePopup, setShowImagePopup] = useState(false);

    const [appointDoctor, setappointDoctor] = useState('')
    const [Error, setError] = useState('')


    const getData = () => {
        axios.post(API_URL + '/view_consultation_details_By_Id', { consultation_id }).then((res) => {
            setData(res.data.fetchConsultation_arr[0]);
            sethospitalResponse(res.data.fetchConsultation_arr[0].hospital_response || [])
            // console.log('asdfa ',res.data.fetchConsultation_arr[0].hospital_response)


        }).catch((error) => {
            console.log(error);

        })

    }

    useEffect(() => {

        if (ClinicId) {

            // console.log('asdf', ClinicId);

            axios.post(API_URL + '/get_Appoint_doctor_By_Id', { clinic_id: ClinicId }).then((res) => {
                console.log(res);

                const formattedDoctor = res.data.doctor_arr.map(doctor => ({
                    label: doctor.doctor_name,
                    value: doctor.doctor_id
                }));
                setdoctorData(formattedDoctor);
                // console.log('doctorrr', formattedDoctor);

            }).catch((error) => {
                console.log(error);

            })
        }
    }, [ClinicId])



    useEffect(() => {
        getData();

    }, [])
    const handleImageClick = (imageUrl) => {
        setEnlargedImage(imageUrl);
        setShowImagePopup(true);
    };
    const handleCloseImage = () => {
        setEnlargedImage(null);
        setShowImagePopup(false);
    };

    return (
        <PageLayout>
            <Col xl={12}>
                <div className="mc-card">
                    <div className='mc-breadcrumb'>
                        <h3 className="mc-breadcrumb-title">{t('consultation_details')}</h3>
                        <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/dashboard'}`} className="mc-breadcrumb-link">{t('home')}</Link></li>
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/manage-consultation'}`} className="mc-breadcrumb-link">{t('consultation')}</Link></li>
                            <li className="mc-breadcrumb-item">{t('consultation_list')}</li>
                        </ul>
                    </div>
                </div>
            </Col>
            <div className="mc-card p-lg-4">
                <Row>
                    <Col xl={9}>
                        <h6 className="mc-divide-title mb-0 ms-2">{t('patient_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row mt-2">

                                        <div className="col-lg-4">
                                            <h6>  {t('name')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.user_name}</span>
                                        </div>


                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('email')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.user_email ? Data.user_email : 'NA'}</span>
                                        </div>

                                    </div>

                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6> {t('mobile')} : </h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{formatPhoneNumber(Data.user_mobile)}</span>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </Col>

                    <Col xl={9}>
                        <h6 className="mc-divide-title mb-0 ms-2">{t('clinic_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row mt-2">

                                        <div className="col-lg-4">
                                            <h6>  {t('name')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.clinic_name}</span>
                                        </div>


                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('email')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.clinic_email ? Data.clinic_email : 'NA'}</span>
                                        </div>

                                    </div>

                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6> {t('mobile')} : </h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{formatPhoneNumber(Data.clinic_mobile)}</span>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </Col>
                    <Col xl={9}>
                        <h6 className="mc-divide-title mb-0 ms-2">{t('doctor_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row mt-2">

                                        <div className="col-lg-4">
                                            <h6>  {t('name')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.doctor_name ? Data.doctor_name : 'NA'}</span>
                                        </div>


                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('email')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.doctor_email ? Data.doctor_email : 'NA'}</span>
                                        </div>

                                    </div>

                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6> {t('mobile')} : </h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{formatPhoneNumber(Data.doctor_mobile)}</span>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </Col>

                    <Col xl={9}>
                        <h6 className="mc-divide-title mb-0 ms-2">{t('consultation_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">


                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6> {t('service')} : </h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.service_name}</span>
                                        </div>

                                    </div>


                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>   {t('document_file')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.document_file && Data.document_file !== 'null' ? (
                                                    <a style={{ color: 'blue', textDecoration: 'underline' }} href={`${Data.document_file}`} target="_blank" rel="noopener noreferrer">
                                                        view
                                                    </a>
                                                ) : (
                                                    'NA'
                                                )}
                                            </span>
                                        </div>

                                    </div>

                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('description')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.description}</span>
                                        </div>

                                    </div>





                                </div>
                            </div>

                        </div>
                    </Col>



                </Row>
                <Row>
                    <Col xl={9}>
                        <div className="mc-product-view-info-group">
                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row mt-0">
                                        <div className="col-lg-4">
                                            <h6>  {t('clinic_inquiry')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {hospitalResponse?.admin_response ? hospitalResponse.admin_response : 'NA'}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('consultation_date')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {hospitalResponse?.date ? moment(hospitalResponse.date).format("DD-MM-YYYY") : 'NA'}
                                            </span>

                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('treatment_plan')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {hospitalResponse?.admin_response_file && hospitalResponse.admin_response_file !== 'null' ? (
                                                    <a style={{ color: 'blue', textDecoration: 'underline' }} href={`${hospitalResponse.admin_response_file}`} target="_blank" rel="noopener noreferrer">
                                                        view
                                                    </a>
                                                ) : 'NA'}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('treatement_fee')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {hospitalResponse?.amount ? `${hospitalResponse.amount}$` : 'NA'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>

                </Row>

            </div>
        </PageLayout>
    )
}